import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import Image from 'next/image';
import React from 'react';
import Slider from 'react-slick';

import { testimonialSettings } from '@/utils/constants/carousel/testimonialSettings';

import Customer1 from '../../../../assets/images/customer-testimonial/customer_1.png';
import Customer2 from '../../../../assets/images/customer-testimonial/customer_2.png';
import Customer3 from '../../../../assets/images/customer-testimonial/customer_3.png';
import Customer4 from '../../../../assets/images/customer-testimonial/customer_4.png';
import Customer5 from '../../../../assets/images/customer-testimonial/customer_5.png';
// import { testimonials } from '@/utils/constants/digital-gold';

export const TestimonialCarousel = () => {
  // const [isMobile, setIsMobile] = useState(false)

  return (
    <div className="mfone-customer-testimonial mt-4">
      <div className="blog-cards-container testimonial-container ">
        <Slider
          {...testimonialSettings}
          variableWidth={true}
          className="carousel-slider"
        >
          <div className="mfone-height-100 pr-2">
            <div className="testimonial-card color-1 mfone-height-100">
              <div className="text-box">
                <div>
                  &quot;<span className="highlight">The best gold loan</span>,
                  from the comfort of home&quot;
                </div>
              </div>
              <div className="profile">
                <Image
                  style={{ color: undefined }}
                  src={Customer1}
                  height={55}
                  alt="Customer 2"
                />
                <div>
                  <p className="title">Mithun</p>
                  <p className="description">Corporate Professional</p>
                </div>
              </div>
            </div>
          </div>
          <div className="mfone-height-100 pr-2">
            <div className="testimonial-card color-2 mfone-height-100">
              <div className="text-box">
                <div>
                  &quot;The{' '}
                  <span className="highlight">processes are quick,</span> and
                  the staff is courteous&quot;
                </div>
              </div>
              <div className="profile">
                <Image
                  style={{ color: undefined }}
                  src={Customer2}
                  height={55}
                  alt="Customer 2"
                />
                <div>
                  <p className="title">Soundhary</p>
                  <p className="description">Homemaker</p>
                </div>
              </div>
            </div>
          </div>
          <div className="mfone-height-100 pr-2">
            <div className="testimonial-card color-3 mfone-height-100">
              <div className="text-box">
                <div>
                  &quot;My Gold Loan From Home experience was{' '}
                  <span className="highlight">
                    fast, smooth, friendly, and most importantly, safe
                  </span>
                  .&quot;
                </div>
              </div>
              <div className="profile">
                <Image
                  style={{ color: undefined }}
                  src={Customer3}
                  height={55}
                  alt="Customer 2"
                />
                <div>
                  <p className="title">Santosh</p>
                  <p className="description">Engineer, major IT firm</p>
                </div>
              </div>
            </div>
          </div>
          <div className="mfone-height-100 pr-2">
            <div className="testimonial-card color-4 mfone-height-100">
              <div className="text-box">
                <div>
                  &quot;
                  <span className="highlight">
                    I come back to Muthoot FinCorp ONE
                  </span>{' '}
                  because of the trust the brand has built with me.&quot;
                </div>
              </div>
              <div className="profile">
                <Image
                  style={{ color: undefined }}
                  src={Customer4}
                  height={55}
                  alt="Customer 2"
                />
                <div>
                  <p className="title">Shubham</p>
                  <p className="description">Businessman</p>
                </div>
              </div>
            </div>
          </div>
          <div className="mfone-height-100 pr-2">
            <div className="testimonial-card color-5 mfone-height-100">
              <div className="text-box">
                <div>
                  &quot;The loan amount was credited to my bank account
                  <span className="highlight"> within minutes</span>.&quot;
                </div>
              </div>
              <div className="profile">
                <Image
                  style={{ color: undefined }}
                  src={Customer5}
                  height={55}
                  alt="Customer 2"
                />
                <div>
                  <p className="title">Ravi Kumar</p>
                  <p className="description">Real Estate Investor</p>
                </div>
              </div>
            </div>
          </div>
        </Slider>
      </div>
    </div>
  );
};
